import React from 'react'
// import { Listings } from '../Listings/Listings'
import { Listings } from '../Listings/Listings'
import once from 'lodash/once'
import { mark } from '@pcln/measure'
import pclnExpt from '@pcln/experimentation'
import { PERF_EVENTS } from '../../../common/constants/perfEvents.js'
import { useFeature } from '@pcln/feature-components'
import { getNumSlices } from '../../util/sbs/sbs.util'
import { isServerSide } from '../../util/isServerSide'
import { useSelector } from 'react-redux'

// Represents approximate number of listings above the fold. Intended to configure render-in-view in <Listings>
// to immediately render those items to improve UX.
const ALWAYS_RENDER_FIRST_N_LISTINGS = 6

const memoizedPerfLog = once((perfEvent) => mark(perfEvent))

const ListingsComponentWrapper = (props) => {
  const perfEvent = PERF_EVENTS.renderGraphListingsStart
  if (!isServerSide) {
    memoizedPerfLog(perfEvent)
  }

  // LaunchDarkly Toggles for Dubai expo 2020
  const isPricelineOnly = useFeature('whiteLabel.isPricelineOnly')
  const checkIfNotInitialLoadOfListing = useSelector((state) => state?.checkIfNotInitialLoadOfListing)
  return (
    <Listings
      pclnExpt={pclnExpt}
      product='AIR'
      alwaysRenderFirstN={ALWAYS_RENDER_FIRST_N_LISTINGS}
      numSlices={getNumSlices()}
      showBaggageFeeLink={isPricelineOnly}
      checkIfNotInitialLoadOfListing={checkIfNotInitialLoadOfListing}
      {...props}
    >
      {props.xSellAd}
    </Listings>
  )
}

export { ListingsComponentWrapper }
